import { render, staticRenderFns } from "./AdminTradeCanReq.vue?vue&type=template&id=5f6ca4b5&scoped=true&"
import script from "./AdminTradeCanReq.vue?vue&type=script&lang=js&"
export * from "./AdminTradeCanReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6ca4b5",
  null
  
)

export default component.exports